import { render } from "./ORGANIZATION_MANAGEMENT.vue?vue&type=template&id=74d79c42"
import script from "./ORGANIZATION_MANAGEMENT.vue?vue&type=script&lang=js"
export * from "./ORGANIZATION_MANAGEMENT.vue?vue&type=script&lang=js"

import "./ORGANIZATION_MANAGEMENT.vue?vue&type=style&index=0&id=74d79c42&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__